<template>
  <td>
    <div v-for="(value, key) in model.meta" :key="key">
      {{ translation[key] }}: {{ value }}
    </div>
    <div>
      User-Agent: <br />
      {{ model.user_agent }}
    </div>
  </td>
</template>

<script>
export default {
  props: ["model"],
  computed: {
    translation() {
      return {
        monitor_resolution: "Auflösung"
      };
    }
  }
};
</script>
